import * as React from 'react';
import { useTranslation } from 'react-i18next';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import GetAppIcon from '@mui/icons-material/GetApp';
import { capitalize } from 'helpers/helpers';

import IconMenu from 'components/IconMenu';
import useGetMenuItems from './hooks/useGetMenuItems';

type Props = {
    className?: string;
    exportTableData?: FlowAnyFunction;
    exportPng?: FlowAnyFunction;
    exportExcelData?: FlowAnyFunction;
};

const ExportMenuContainer = ({
    className = undefined,
    exportTableData = undefined,
    exportPng = undefined,
    exportExcelData = undefined,
}: Props): React.ReactElement => {
    const { t } = useTranslation();

    const menuItems = useGetMenuItems(
        exportTableData,
        exportPng,
        exportExcelData,
    );

    // We don't want to show an empty menu while data is loading
    if (menuItems.length === 0) return <></>;

    const menuItemComponents = menuItems.map((item) => (
        <MenuItem onClick={item.action} key={item.name}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            {item.name}
        </MenuItem>
    ));
    return (
        <IconMenu
            className={className}
            iconElement={<GetAppIcon fontSize="small" />}
            tooltip={capitalize(t('common.export'))}
            tooltipPlacement="bottom"
            color="primary"
        >
            {menuItemComponents}
        </IconMenu>
    );
};

export default ExportMenuContainer;
